import { Trans } from '@lingui/macro';
import React, {
    useEffect, useState
} from 'react';
import { useDispatch } from 'react-redux';

import genericErrorImage from '../../../../../../assets/images/error_generic.svg';
import { ScriptState } from '../../../../../hooks/use-script';
import { closeModal } from '../../../../index';
import { fetchDucsContent } from '../../../modals/variants/ducs';
import { useDucsConfiguration } from './ducs-modal.selector';
import {
    DucsModalContent, DucsModalWrapper, Footer, ErrorContent,
    DucsCarousel, CarouselButton, CarouselIndicators, CarouselIndicator,
    ErrorImage
} from './ducs-modal.styled';
import { DucsModalProps } from './ducs-modal.types';
import {
    LoadingView, Button,
    TeacherAdminIcon
} from '@components';
import { useDucs } from '@ducs';

export const DucsModal = (props: DucsModalProps) => {
    const { message: girlIds } = props;
    const [selectedGirldIdIndex, setSelectedGirlIdIndex] = useState(0);
    const [selectedGirlId, setSelectedGirlId] = useState<string>(girlIds[selectedGirldIdIndex] || '');
    const dispatch = useDispatch();
    const {
        initDucs, status
    } = useDucs();
    const {
        data, isLoading, isError
    } = useDucsConfiguration();

    useEffect(() => {
        dispatch(fetchDucsContent(selectedGirlId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedGirlId]);

    useEffect(() => {
        if (status === ScriptState.ready && data !== null) {
            initDucs({
                targetDom: '.ducs-event-container',
                selectedConfiguration: data
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [status, data]);

    const loadPreviousGirlId = () => {
        if (selectedGirldIdIndex > 0) {
            setSelectedGirlIdIndex(selectedGirldIdIndex => {
                return (selectedGirldIdIndex > 0) ? selectedGirldIdIndex - 1 : 0;
            });
        }
    };
    const loadNextGirlId = () => {
        if (selectedGirldIdIndex < girlIds.length - 1) {
            setSelectedGirlIdIndex(selectedGirldIdIndex => {
                return (selectedGirldIdIndex < girlIds.length - 1) ? selectedGirldIdIndex + 1 : girlIds.length - 1;
            });
        }
    };
    const handleCarouselIndictorClick = (girlId: string) => {
        setSelectedGirlId(girlId);
        const girlIdIndex = girlIds.findIndex(id => id === girlId);

        setSelectedGirlIdIndex(girlIdIndex);
    };

    useEffect(() => {
        setSelectedGirlId(girlIds[selectedGirldIdIndex]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedGirldIdIndex]);

    return (
        <DucsModalWrapper>
            {
                (isLoading || status === ScriptState.loading) ?
                    <LoadingView /> :
                    (<>
                        <DucsModalContent className={'ducs-event-container'} />
                        { isError &&
                            <ErrorContent>
                                <ErrorImage src={genericErrorImage} />
                            </ErrorContent>
                        }
                        { (girlIds.length > 1) &&
                        <DucsCarousel>
                            <CarouselButton onClick={loadPreviousGirlId}>
                                <TeacherAdminIcon
                                    icon={'left_solid'}
                                    width={30}
                                />
                            </CarouselButton>
                            <CarouselIndicators>
                                {
                                    girlIds.map(girlId => (
                                        <CarouselIndicator
                                            key={girlId}
                                            onClick={() => handleCarouselIndictorClick(girlId)}
                                            bgColor={girlId === selectedGirlId ? 'neutral.500' : 'neutral.300'}
                                        />
                                    ))
                                }
                            </CarouselIndicators>
                            <CarouselButton onClick={loadNextGirlId}>
                                <TeacherAdminIcon
                                    icon={'right_solid'}
                                    width={30}
                                />
                            </CarouselButton>
                        </DucsCarousel>
                        }
                        <Footer>
                            <Button
                                onClick={() => dispatch(closeModal())}
                                data-testid={'ducs-modal-close-btn'}
                            >
                                { isError ? <Trans id={'button.ok'} /> :<Trans id={'ducsModal.gotIt'} /> }
                            </Button>
                        </Footer>
                    </>)}
        </DucsModalWrapper>
    );
};
